export const filterDivider = <T>(arr: T[], cb: (item: T) => boolean): T[][] =>
  arr.reduce(
    (prev: T[][], cur: T) => (cb(cur) ? [[...prev[0], cur], [...prev[1]]] : [[...prev[0]], [...prev[1], cur]]),

    [[], []],
  );
